// extracted by mini-css-extract-plugin
export var chip = "_re-2";
export var chipBody = "_re-8";
export var chipHeader = "_re-9";
export var chipWithKind = "_re-7";
export var icon = "_re-3";
export var kind = "_re-a";
export var remove = "_re-5";
export var removeIcon = "_re-6";
export var row = "_re-0";
export var rowHistorical = "_re-1";
export var text = "_re-4";